import {
  collection,
  doc,
  getDoc,
  setDoc,
  addDoc,
  updateDoc,
  getFirestore,
  runTransaction,
  connectFirestoreEmulator,
  deleteDoc,
  query,
  where,
  getDocs
} from 'firebase/firestore'
import { getApp } from './firebase'
import { USER_COLLECTION } from '../config'
import { IS_DEV } from '../config'

const db = getFirestore(getApp())
const usersRef = collection(db, USER_COLLECTION)

if (IS_DEV) {
  connectFirestoreEmulator(db, 'localhost', 8080)
}

// Gets a user from docRef
export const getUserFromDocRef = docRef => {
  return getDoc(docRef)
}

// Gets a user with id
export const getUser = id => {
  return getDoc(doc(usersRef, id))
}

// Creates or overwrites a user with id
export const setUser = (id, user) => {
  return setDoc(doc(usersRef, id), user)
}

// Creates a user (with random ID)
export const addUser = user => {
  return addDoc(usersRef, user)
}

// Updates a user with id
export const updateUser = (id, user) => {
  return updateDoc(doc(usersRef, id), user)
}

// Updates a user with id
export const addOrUpdateUser = (id, user) => {
  return runTransaction(db, async transaction => {
    const userDocRef = doc(usersRef, id)
    const userDoc = await transaction.get(userDocRef)
    if (!userDoc.exists()) {
      // Create user
      transaction.set(userDocRef, user)
    } else {
      // Update user
      transaction.update(userDocRef, user)
    }
  })
}

export const migrateDb = async () => {
  const q = query(
    usersRef
    // where('uid', '==', '')
  )

  const querySnapshot = await getDocs(q)
  querySnapshot.forEach(async sDoc => {
    // deleteDoc(doc(usersRef, sDoc.id))
    // const data = sDoc.data()
    // const index = 'IndexCoop'
    // await updateDoc(sDoc.ref, { firstDao: index, daos: [index] })
    // console.log(sDoc.id, data)
    // if (data?.account) {
    // await updateDoc(sDoc.ref, { sso: 'wallet' })
    // console.log(sDoc.id, data)
    // } else {
    //   await updateDoc(sDoc.ref, { sso: 'email' })
    //   console.log(sDoc.id, data)
    // }
  })
}
